import React, { Component } from "react";

import { withFirebase } from "../Firebase";
import { Grid, Row, Col } from "react-flexbox-grid";
import { DateInput, TimePicker } from "@blueprintjs/datetime";

import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import Repeat from "react-repeat-component";
import Collapse from "react-collapse";
import { isEqual } from "lodash";

import RichTextEditor from "../RichTextEditor";
import ImageUpload from "../ImageUpload";
import FormCreation from "../FormCreation";

import "./index.css";

import {
  Intent,
  NumericInput,
  Position,
  Switch,
  InputGroup,
  Checkbox,
  Button,
  RadioGroup,
  Radio,
} from "@blueprintjs/core";

const jsDateFormatter = {
  // note that the native implementation of Date functions differs between browsers
  formatDate: (date) => date.toLocaleDateString(),
  parseDate: (str) => new Date(str),
  placeholder: "M/D/YYYY",
};

class EditEvent extends Component {
  event_date = [];

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      confirmation_type: this.props.details.confirmation_type,
      event_name: this.props.details.event_name,
      event_name_ar: this.props.details.event_name_ar,
      isGuest: this.props.details.isGuest,
      isCanceled: this.props.details.isCanceled,
      event_description:
        this.props.details.description === undefined
          ? "N/A"
          : this.props.details.description,
      difficulty: this.props.details.difficulty,
      capacity: this.props.details.max_attendees,
      livestream: this.props.details.livestream,
      waitlist: this.props.details.waitlist,
      numdays: this.props.details.ndays,
      event_date: this.clone(this.props.details.event_date_formated),
      instructors: this.props.instructors,
      contributors: [],
      expected_attendees: this.props.details.expected_attendees,
      venue: this.props.details.venue,
      city: this.props.details.city,
      center_type: props.details.hasOwnProperty("center_type")
        ? props.details.center_type
        : "ai-ds",
      event_type: this.props.details.event_type.hasOwnProperty("value")
        ? this.props.details.event_type.value
        : this.props.details.event_type,
      venues: [],
      dropdownFlag: false,
      googleMaps: this.props.details.google_maps,
      programs: [],
      program: this.props.details.program,
      programIsNew: false,
      venueIsNew: false,
      notes: this.props.details.notes,
      for_whom: this.props.details.for_whom,
      desc_rte: this.props.details.desc_webflow,
      short_desc: this.props.details.short_desc,
      see_more: this.props.details.see_more,
      imageProps: this.props.details.hasOwnProperty("imageProps")
        ? this.props.details.imageProps
        : "",
      nlive_streams:
        this.props.details.nlive_streams === undefined
          ? 0
          : this.props.details.nlive_streams,
      questions: this.props.details.hasOwnProperty("form")
        ? this.props.details.form.hasOwnProperty("questions")
          ? this.props.details.form.questions
          : {}
        : {},
      form: {
        event_id: this.props.details.form.event_id,
        questions: this.props.details.form.questions,
      },
      target_audience: this.props.details.hasOwnProperty("target_audience")
        ? this.props.details.target_audience
        : "",
      isOpenGeneral: true,
      isOpenDate: true,
      isOpenStatistics: true,
      isOpenSettings: true,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  clone(obj) {
    let copy;

    if (null === obj || "object" !== typeof obj) return obj;

    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
      }
      return copy;
    }
  }

  setCategory = (program) => {
    this.props.firebase.programs().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().name === program) {
          console.log(doc.data().category);
          this.setState({ category: doc.data().category });
        }
      });
    });
  };

  getGoogleMapsLink(venue) {
    this.props.firebase.venues().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().name === venue) {
          this.setState({ googleMaps: doc.data().google_maps });
        }
      });
    });
  }
  componentDidMount() {
    var contributors = this.state.contributors;
    this.props.firebase.teamMembers().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        console.log(doc.data());
        var user_ref = doc.data().user;
        if (user_ref)
          user_ref.get().then((doc) => {
            console.log(doc.id, doc.data());
            contributors.push({
              label: doc.data().firstname + " " + doc.data().familyname,
              value: doc.id,
              collection: "users",
            });
          });
      });
    });

    this.setState({
      contributors: contributors,
    });

    var venues = this.state.venues;
    this.props.firebase.venues().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        venues.push({
          label: doc.data().name,
          value: doc.id,
        });
      });
    });
    this.setState({ venues: venues });
    var programs = this.state.programs;
    this.props.firebase.programs().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        programs.push({
          label: doc.data().name,
          value: doc.id,
        });
      });
    });
    this.setState({ programs: programs });
  }

  onValueChange = (num, string) => {
    if (num !== 0) {
      this.setState({ numdays: num });

      var preFunctionArray = this.state.event_date;

      while (preFunctionArray.length > num) {
        preFunctionArray.pop();
      }
      //in the case of no excess being removed, these two arrays are the same
      var removedExcessArray = preFunctionArray;

      this.setState({
        eventDate: removedExcessArray,
      });
      var local_event_date = this.state.event_date;
      //this part of the function adds values to the eventDate if required.
      //will not run if theres no need to add anymore values
      if (removedExcessArray.length < num) {
        for (var i = removedExcessArray.length; i < num; i++) {
          var local_date_object = {
            date: new Date(),
            start_time: new Date(),
            end_time: new Date(),
          };
          local_event_date.push(local_date_object);
        }
        this.setState({ event_date: local_event_date });
      }
    }
  };

  setDay = (newDay, i) => {
    var event_date = this.state.event_date;
    event_date[i].date = newDay;
    this.setState({ event_date: event_date });
  };

  setStartTime = (newTime, i) => {
    var event_date = this.state.event_date;
    event_date[i].start_time = newTime;
    event_date[i].date.setHours(newTime.getHours());
    event_date[i].date.setMinutes(newTime.getMinutes());
    event_date[i].date.setSeconds(0);
    event_date[i].date.setMilliseconds(0);
    this.setState({ event_date: event_date });
  };

  setEndTime = (newTime, i) => {
    var event_date = this.state.event_date;
    event_date[i].end_time = newTime;
    this.setState({ event_date: event_date });
  };

  handleTypeRadioChange = (event) =>
    this.setState({
      event_type: event.currentTarget.value,
    });

  handleDifficultyRadioChange = (event) =>
    this.setState({
      difficulty: event.currentTarget.value,
    });

  handleNumberOfQuestionsChange = (num) => {
    var form = this.state.form;
    while (num > form.questions.length) {
      form.questions.push("");
    }
    while (num < form.questions.length) {
      form.questions.pop();
    }
    this.setState({ form: form });
  };

  setQuesions = (questions) => {
    console.log(questions);
    this.setState({ quesions: questions });
  };

  handleQuestionTextChange = (event, i) => {
    var form = this.state.form;
    form.questions[i] = event.target.value;
    this.setState({ form: form });
  };

  //sends data to parent and submits
  handleSubmit = () => {
    let details = {
      eventInstructors: this.state.instructors,
      eventDetails: {
        id: this.props.details.id,
        event_name: this.state.event_name,
        event_name_ar: this.state.event_name_ar,
        max_attendees: this.state.capacity,
        nWaiting: this.props.details.nWaiting,
        nRegistered: this.props.details.nRegistered,
        nAttended: this.props.details.nAttended,
        nConfirmed: this.props.details.nConfirmed,
        waitlist: this.state.waitlist,
        confirmation_type: this.state.confirmation_type,
        ndays: this.state.numdays,
        difficulty: this.state.difficulty,
        city: this.state.city,
        center_type: this.state.center_type,
        expected_attendees: this.state.expected_attendees,
        livestream: this.state.livestream,
        venue: this.state.venue,
        program: this.state.program,
        category: this.state.category,
        isCanceled: this.state.isCanceled,
        isGuest: this.state.isGuest,
        google_maps: this.state.googleMaps,
        event_date_formated: this.state.event_date,
        event_type: this.state.event_type,
        desc_webflow: this.state.desc_rte,
        short_desc: this.state.short_desc,
        for_whom: this.state.for_whom,
        see_more: this.state.see_more,
        notes: this.state.notes,
        imageProps: this.state.imageProps,
        nlive_streams: this.state.nlive_streams,
        form: this.state.form,
        target_audience: this.state.target_audience,
      },
    };

    this.updateFirebase(details);
    this.props.handleSubmit(details);
  };

  setImageProps = (url, name, size, type) => {
    this.setState({
      imageProps: {
        imageUrl: url,
        imageName: name,
        imageSize: size,
        imageType: type,
      },
    });
  };

  handelGeneral = () => {
    this.setState({ isOpenGeneral: !this.state.isOpenGeneral });
  };
  handelDate = () => {
    this.setState({ isOpenDate: !this.state.isOpenDate });
  };
  handelStatistics = () => {
    this.setState({ isOpenStatistics: !this.state.isOpenStatistics });
  };
  handelSettings = () => {
    this.setState({ isOpenSettings: !this.state.isOpenSettings });
  };

  render() {
    let targetAudianceOptions = [
      {
        label: "General Events (فعاليات عامة)",
        value: "General Events",
      },
      {
        label: "Entrepreneurs (رواد أعمال)",
        value: "Entrepreneurs",
      },
      {
        label: "SMEs (أصحاب منشآت صغيرة ومتوسطة)",
        value: "SMEs",
      },
    ];

    return (
      <form>
        <Grid>
          <Row>
            <button
              type="button"
              onClick={() => this.handelGeneral()}
              className="box"
            >
              General Information
            </button>
            <Collapse
              isOpened={this.state.isOpenGeneral}
              className="collapse-style"
            >
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event name:</strong>
                </Col>
                <Col xs={6}>
                  <InputGroup
                    defaultValue={this.props.details.event_name}
                    onChange={(input) =>
                      this.setState({ event_name: input.target.value })
                    }
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event name (arabic):</strong>
                </Col>
                <Col xs={6}>
                  <InputGroup
                    defaultValue={this.props.details.event_name_ar}
                    onChange={(input) =>
                      this.setState({ event_name_ar: input.target.value })
                    }
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Program</strong>
                </Col>
                <Col xs={6}>
                  <CreatableSelect
                    value={{ label: this.state.program, value: "program" }}
                    onInputChange={(event, action) => {}}
                    onChange={(event, action) => {
                      this.setState({
                        program: event.label,
                      });

                      this.setCategory(event.label);
                      this.setState({ programIsNew: false });
                    }}
                    onCreateOption={(string) => {
                      this.setState({ program: string });
                      this.setState({ programIsNew: true });
                    }}
                    options={this.state.programs}
                    defaultValue={{
                      value: true,
                      label: this.state.program,
                    }}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>Instructor is Guest:</strong>
                </Col>
                <Checkbox
                  label=""
                  checked={this.state.isGuest}
                  onChange={() =>
                    this.setState({ isGuest: !this.state.isGuest })
                  }
                />
              </Row>
              <Row>
                <Col xs={3}>
                  <strong>Instructors</strong>
                </Col>
                <Col xs={6}>
                  <Select
                    //value={this.state.instructors}
                    options={this.state.contributors}
                    isMulti
                    onChange={(value) => {
                      if (value !== null) {
                        let filterlist = [];
                        for (let i = 0; i < value.length; i++) {
                          var instructor = {
                            name: value[i].label,
                            collection: value[i].collection,
                            id: value[i].value,
                          };
                          filterlist.push(instructor);
                        }

                        this.setState({ instructors: filterlist });
                      } else {
                        this.setState({ instructors: [] });
                      }
                    }}
                    defaultValue={this.state.instructors.map((i) => {
                      return {
                        value: i.id,
                        label: i.name,
                        collection: i.collection,
                      };
                    })}
                  ></Select>
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Venue:</strong>
                </Col>
                <Col xs={6}>
                  <CreatableSelect
                    value={{ label: this.state.venue, value: "venue" }}
                    onInputChange={(event, action) => {}}
                    onChange={(event, action) => {
                      this.setState({ venue: event.label });
                      this.getGoogleMapsLink(event.label);
                      this.setState({ venueIsNew: false });
                    }}
                    onCreateOption={(string) => {
                      this.setState({ venue: string });
                      this.setState({ venueIsNew: true });
                    }}
                    options={this.state.venues}
                    defaultValue={this.state.venues}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Google Maps Reference:</strong>
                </Col>
                <Col xs={6}>
                  <InputGroup
                    disabled={!this.state.venueIsNew}
                    value={this.state.googleMaps}
                    onChange={(event) => {
                      this.setState({ googleMaps: event.target.value });
                    }}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Center Type: </strong>
                </Col>
                <Col xs={6}>
                  <RadioGroup
                    inline
                    label="Center Type"
                    selectedValue={this.state.center_type}
                    onChange={(event) => {
                      this.setState({
                        center_type: event.target.value,
                      });
                    }}
                    defaultValue={{
                      value: true,
                      label: this.state.center_type,
                    }}
                  >
                    <Radio label="IoT / CyS" value="iot-cys" />
                    <Radio label="AI/DS" value="ai-ds" />
                  </RadioGroup>
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>City: </strong>
                </Col>
                <Col xs={6}>
                  <Select
                    options={[
                      {
                        label: "عبر الإنترنت ( Webinar )",
                        value: "عبر الإنترنت ( Webinar )",
                      },
                      { label: "", value: "" },
                      { label: "الخبر", value: "الخبر" },
                      { label: "الرياض", value: "الرياض" },
                      { label: "الجبيل", value: "الجبيل" },
                      { label: "جدة", value: "جدة" },
                      { label: "Riyadh", value: "Riyadh" },
                      { label: "المدينة المنورة", value: "المدينة المنورة" },
                      { label: "المدينة", value: "المدينة" },
                      { label: "الاحساء", value: "الاحساء" },
                      { label: "Dubai", value: "Dubai" },
                    ]}
                    onChange={(value) => {
                      this.setState({ city: value.value });
                    }}
                    defaultValue={{ value: true, label: this.state.city }}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event Type:</strong>
                </Col>
                <Col xs={4}>
                  <Select
                    options={[
                      { label: "Webinar", value: "Webinar" },
                      { label: "Lecture", value: "Lecture" },
                      { label: "Bootcamp", value: "Bootcamp" },
                      { label: "Other", value: "Other" },
                      { label: "Meet-Up", value: "Meet-Up" },
                      { label: "Consultations", value: "Consultations" },
                      { label: "Internal", value: "Internal" },
                      { label: "Challenges", value: "Challenges" },
                      { label: "External", value: "External" },
                      { label: "Conference ", value: "Conference " },
                    ]}
                    onChange={(value) => {
                      this.setState({ event_type: value.value });
                    }}
                    defaultValue={{
                      value: true,
                      label: this.state.event_type,
                    }}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Confirmation Type:</strong>
                </Col>
                <Col xs={6}>
                  <RadioGroup
                    inline
                    name="group"
                    selectedValue={this.state.confirmation_type}
                    onChange={(event) => {
                      this.setState({
                        confirmation_type: event.target.value,
                      });
                    }}
                  >
                    <Radio label="Auto Confirm" value="auto_confirm" />
                    <Radio label="Filter Applicants" value="filter" />
                  </RadioGroup>
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>Livestream:</strong>
                </Col>
                <Col xs={6}>
                  <Switch
                    checked={this.state.livestream}
                    onChange={(event) => {
                      this.setState({
                        livestream: event.target.checked,
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Waitlist:</strong>
                </Col>
                <Col xs={6}>
                  <Switch
                    checked={this.state.waitlist}
                    onChange={(event) => {
                      this.setState({
                        waitlist: event.target.checked,
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event is canceled:</strong>
                </Col>

                <Checkbox
                  label=""
                  checked={this.state.isCanceled}
                  onChange={() =>
                    this.setState({ isCanceled: !this.state.isCanceled })
                  }
                />
              </Row>
            </Collapse>
          </Row>
          <Row>
            <button
              type="button"
              onClick={() => this.handelDate()}
              className="box"
            >
              Date & Time
            </button>
            <Collapse
              isOpened={this.state.isOpenDate}
              className="collapse-style"
            >
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Number of days</strong>
                </Col>
                <Col xs={2}>
                  <NumericInput
                    buttonPosition="none"
                    value={this.state.numdays}
                    onValueChange={this.onValueChange}
                    allowNumericCharactersOnly={true}
                    min={0}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Repeat times={this.state.numdays}>
                  {(i) => (
                    <div className="margin-below" key={i}>
                      <div style={{ float: "left" }}>
                        <Row middle="xs">
                          <Col xs={6}>
                            <strong>Day {i + 1}</strong> :
                          </Col>
                          <Col xs={6}>
                            <DateInput
                              {...jsDateFormatter}
                              className="display-block"
                              popoverProps={{ position: Position.BOTTOM }}
                              maxDate={new Date(2040, 11, 11)}
                              onChange={(newDay) => {
                                this.setDay(newDay, i);
                              }}
                              value={this.state.event_date[i].date}
                            />
                          </Col>
                        </Row>

                        <Row middle="xs">
                          <Col xs={6}>
                            <strong>Start Time:</strong>
                          </Col>
                          <Col xs={6}>
                            <TimePicker
                              onChange={(newTime) => {
                                this.setStartTime(newTime, i);
                              }}
                              value={this.state.event_date[i].start_time}
                            />
                          </Col>
                        </Row>

                        <Row middle="xs">
                          <Col xs={6}>
                            <strong>End Time:</strong>
                          </Col>
                          <Col xs={6}>
                            <TimePicker
                              onChange={(newTime) => {
                                this.setEndTime(newTime, i);
                              }}
                              value={this.state.event_date[i].end_time}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Repeat>
              </Row>
            </Collapse>
          </Row>
          <Row>
            <button
              type="button"
              onClick={() => this.handelStatistics()}
              className="box"
            >
              Statistics
            </button>
            <Collapse
              isOpened={this.state.isOpenStatistics}
              className="collapse-style"
            >
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event capacity:</strong>
                </Col>
                <Col xs={6}>
                  <NumericInput
                    buttonPosition="none"
                    allowNumericCharactersOnly={true}
                    large={false}
                    min={0}
                    onValueChange={(value) => {
                      this.setState({ capacity: value });
                    }}
                    value={this.state.capacity}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Expected Number of Attendees:</strong>
                </Col>
                <Col xs={6}>
                  <NumericInput
                    buttonPosition="none"
                    allowNumericCharactersOnly={true}
                    large={false}
                    min={0}
                    onValueChange={(value) => {
                      this.setState({ expected_attendees: value });
                    }}
                    value={this.state.expected_attendees}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>Number of live streams:</strong>
                </Col>
                <Col xs={6}>
                  <NumericInput
                    buttonPosition="none"
                    allowNumericCharactersOnly={true}
                    large={false}
                    min={0}
                    value={this.state.nlive_streams}
                    onValueChange={(value) => {
                      this.setState({ nlive_streams: value });
                    }}
                  />
                </Col>
              </Row>
            </Collapse>
          </Row>
          <Row>
            <button
              type="button"
              onClick={() => this.handelSettings()}
              className="box"
            >
              Webflow & Email Settings
            </button>
            <Collapse
              isOpened={this.state.isOpenSettings}
              className="collapse-style"
            >
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Target Audiance:</strong>
                </Col>
                <Col xs={4}>
                  <Select
                    options={targetAudianceOptions}
                    onChange={(value) => {
                      this.setState({ target_audience: value.value });
                    }}
                    defaultValue={{
                      value: true,
                      label:
                        targetAudianceOptions.filter(
                          (option) =>
                            option.value === this.state.target_audience
                        ).length === 0
                          ? ""
                          : targetAudianceOptions.filter(
                              (option) =>
                                option.value === this.state.target_audience
                            )[0].label,
                    }}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>Difficulty/Level:</strong>
                </Col>
                <Col xs={6}>
                  <RadioGroup
                    inline
                    selectedValue={this.state.difficulty}
                    onChange={this.handleDifficultyRadioChange}
                  >
                    <Radio label="Easy" value="Easy" />
                    <Radio label="Medium" value="Medium" />
                    <Radio label="Hard" value="Hard" />
                  </RadioGroup>
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>For whom:</strong>
                </Col>
                <Col xs={6}>
                  <InputGroup
                    value={this.state.for_whom}
                    onChange={(input) => {
                      this.setState({ for_whom: input.target.value });
                    }}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event Description: (Short)</strong>
                </Col>
                <Col xs={6}>
                  <InputGroup
                    value={this.state.short_desc}
                    onChange={(input) => {
                      this.setState({ short_desc: input.target.value });
                    }}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event Description: </strong>
                </Col>
                <Col xs={6}>
                  <RichTextEditor
                    data={this.state.desc_rte}
                    parentCallback={(data) => {
                      console.log(data);
                      this.setState({ desc_rte: data });
                    }}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>See more description:</strong>
                </Col>
                <Col xs={6}>
                  <RichTextEditor
                    data={this.state.see_more}
                    parentCallback={(data) => {
                      console.log(data);
                      this.setState({ see_more: data });
                    }}
                  />
                </Col>
              </Row>

              <Row middle="xs">
                <Col xs={3}>
                  <strong>Event Notes:</strong>
                </Col>
                <Col xs={6}>
                  <RichTextEditor
                    data={this.state.notes}
                    parentCallback={(data) => {
                      console.log(data);
                      this.setState({ notes: data });
                    }}
                  />
                </Col>
              </Row>
              <Row middle="xs">
                <Col xs={3}>
                  <strong>Description Image:</strong>
                </Col>
                <Col xs={6}>
                  <ImageUpload
                    id={this.props.details.id}
                    allowMultiple={false}
                    url={`events/${this.props.details.id}/assets/`}
                    setImageProps={this.setImageProps}
                    imageProps={this.state.imageProps}
                  />
                </Col>
              </Row>

              <Row top="xs">
                <Col xs={3}>
                  <strong>Number of questions:</strong>
                </Col>
                <Col xs={6}>
                  <FormCreation
                    nQuestions={this.state.questions.length}
                    getQuestions={(questions) => {
                      console.log(questions);
                      this.setQuesions(questions);
                    }}
                    questions={this.state.questions}
                  />
                </Col>
              </Row>
            </Collapse>
          </Row>
        </Grid>
        <Button
          className=".btn"
          icon="saved"
          intent={Intent.PRIMARY}
          onClick={() => this.handleSubmit()}
        >
          Save
        </Button>
      </form>
    );
  }

  updateFirebase = (details) => {
    let ref = this.props.firebase.event(this.props.details.id);
    details.eventDetails.event_name === this.props.details.event_name
      ? console.log("no update to event_name")
      : ref.update({
          event_name: details.eventDetails.event_name,
        });

    details.eventDetails.event_name_ar === this.props.details.event_name_ar
      ? console.log("no update to event_name_ar")
      : ref.update({
          event_name_ar: details.eventDetails.event_name_ar,
        });

    details.eventDetails.program === this.props.details.program
      ? console.log("no update to program")
      : ref.update({
          program: details.eventDetails.program,
          category: details.eventDetails.category,
        });

    details.eventDetails.max_attendees === this.props.details.max_attendees
      ? console.log("no update to max_attendees")
      : ref.update({
          max_attendees: details.eventDetails.max_attendees,
        });

    isEqual(details.eventInstructors, this.props.instructors)
      ? console.log("no update to instructors")
      : ref.update({
          instructors: this.state.instructors.map((instructor) =>
            this.props.firebase.ref(instructor.id, instructor.collection)
          ),
        });

    details.eventDetails.city === this.props.details.city
      ? console.log("no update to city")
      : ref.update({
          city: details.eventDetails.city,
        });

    details.eventDetails.center_type === this.props.details.center_type
      ? console.log("no update to center_type")
      : ref.update({
          center_type: details.eventDetails.center_type,
        });

    details.eventDetails.event_type === this.props.details.event_type
      ? console.log("no update to event_type")
      : ref.update({
          event_type: details.eventDetails.event_type,
        });

    details.eventDetails.nlive_streams === this.props.details.nlive_streams
      ? console.log("no update to nlive_streams")
      : ref.update({
          nlive_streams: details.eventDetails.nlive_streams,
        });

    details.eventDetails.confirmation_type ===
    this.props.details.confirmation_type
      ? console.log("no update to confirmation_type")
      : ref.update({
          confirmation_type: details.eventDetails.confirmation_type,
        });

    details.eventDetails.expected_attendees ===
    this.props.details.expected_attendees
      ? console.log("no update to expected_attendees ")
      : ref.update({
          expected_attendees: details.eventDetails.expected_attendees,
        });

    details.eventDetails.difficulty === this.props.details.difficulty
      ? console.log("no update to difficulty")
      : ref.update({
          difficulty: details.eventDetails.difficulty,
        });

    details.eventDetails.livestream === this.props.details.livestream
      ? console.log("no update to livestream")
      : ref.update({
          livestream: details.eventDetails.livestream,
        });

    details.eventDetails.isGuest === this.props.details.isGuest
      ? console.log("no update to isGuest")
      : ref.update({
          isGuest: details.eventDetails.isGuest,
        });

    details.eventDetails.isCanceled === this.props.details.isCanceled
      ? console.log("no update to isCanceled")
      : ref.update({
          isCanceled: details.eventDetails.isCanceled,
        });
    details.eventDetails.waitlist === this.props.details.waitlist
      ? console.log("no update to waitlist")
      : ref.update({
          waitlist: details.eventDetails.waitlist,
        });

    details.eventDetails.venue === this.props.details.venue
      ? console.log("no update to venue")
      : ref.update({
          venue: details.eventDetails.venue,
          google_maps: details.eventDetails.google_maps,
        });

    isEqual(
      details.eventDetails.event_date_formated,
      this.props.details.event_date_formated
    )
      ? console.log("no update to date to event_date_formated")
      : ref.update({
          event_date: details.eventDetails.event_date_formated,
        });

    //desc_webflow, short_desc, for_whom, notes, see more, images
    details.eventDetails.short_desc === this.props.details.short_desc
      ? console.log("no update to short_desc")
      : ref.update({
          short_desc: details.eventDetails.short_desc,
        });

    details.eventDetails.desc_webflow === this.props.details.desc_webflow
      ? console.log("no update to desc_webflow")
      : ref.update({
          desc_webflow: details.eventDetails.desc_webflow,
        });

    details.eventDetails.see_more === this.props.details.see_more
      ? console.log("no update to see_more")
      : ref.update({
          see_more: details.eventDetails.see_more,
        });

    details.eventDetails.for_whom === this.props.details.for_whom
      ? console.log("no update to for_whom")
      : ref.update({
          for_whom: details.eventDetails.for_whom,
        });

    details.eventDetails.notes === this.props.details.notes
      ? console.log("no update to notes")
      : ref.update({
          notes: details.eventDetails.notes,
        });

    details.eventDetails.imageProps === this.props.details.imageProps
      ? console.log("no update to imageProps")
      : ref.update({
          imageProps: details.eventDetails.imageProps,
        });

    if (this.props.details.form !== {}) {
      details.eventDetails.form === this.props.details.form
        ? console.log("no update to form")
        : ref.update({
            form: details.eventDetails.form,
          });
    }

    details.eventDetails.target_audience === this.props.details.target_audience
      ? console.log("no update to target_audience")
      : ref.update({
          target_audience: details.eventDetails.target_audience,
        });
  };
}

export default withFirebase(EditEvent);
